import * as React from 'react'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import red from '@material-ui/core/colors/red'

const textFieldFocusColor = red[900]

const theme = createMuiTheme({
  palette: {
    primary: {
      main: red[900]
    },
    error: {
      main: red[900]
    },
    background: {
      default: '#8e0c14'
    }
  },
  typography: {
    useNextVariants: true
  },
  overrides: {
    MuiFormLabel: {
      focused: {
        '&$focused': {
          color: textFieldFocusColor
        }
      }
    },
    MuiInput: {
      underline: {
        '&:after': {
          borderBottom: `2px solid ${textFieldFocusColor}`
        }
      }
    },
    MuiSelect: {
      select: {
        '&:focus': {
          background: 'transparent'
        }
      }
    },
    MuiStepIcon: {
      root: {
        color: 'gray',
        '&$completed': 'green'
      },
      completed: {
        color: 'green'
      }
    }
  }
})

function withMUI<P>(Component: React.ComponentType<P>) {
  function WithMUI(props: P) {
    return (
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <Component {...props} />
      </MuiThemeProvider>
    )
  }

  WithMUI.displayName = `WithMUI(${Component.displayName || Component.name})`

  return WithMUI
}

export default withMUI



// WEBPACK FOOTER //
// ./src/withMUI.tsx